import L from 'leaflet';
import { useEffect, useState } from "react";

import "leaflet.vectorgrid";

import { useConfig } from '../../../Services/useConfig';
import useTranslation from '../../../Language/useTranslation';


var core = require("@react-leaflet/core");

function createMVT(props: any, context: any) {
    const instance = L.vectorGrid.protobuf(props.url, props.options);
    return {
        instance: instance,
        context: { ...context, overlayContainer: instance },
    };
}

function updateMVT(instance: any, props: any, prevProps: any) { }

const TileSchadflaechenSelectedComponent = core.createPathComponent(createMVT, updateMVT);

export function SchadflaechenSelectedLayer(props: any) {

    const t = useTranslation()
    const schadflaechenStyles = {
        Bundeslaender_Waldzustand: function (properties: any, zoom: any) {
            // Ref: https://leafletjs.com/reference-1.7.1.html#path

            if (properties.RS == props.selectedAreaId) {
                return {
                    // Stroke properties
                    stroke: true,
                    color: "white",
                    weight: 1.7,

                    // opacity: 1
                }
            } else {
                return {
                    stroke: false

                }
            }
        },
    };

    // const GEOSERVER_PREFIX = "http://rsswebserver.rssgmbh.intern:8080";
    // const GEOSERVER_PREFIX = "https://map3d.remote-sensing-solutions.de";
    // const gsLayer = "wmde:Bundeslaender_Waldzustand"
    // const layerUrl = GEOSERVER_PREFIX + '/geoserver/gwc/service/tms/1.0.0/' + gsLayer + '@EPSG:900913' + '@pbf/{z}/{x}/{-y}.pbf'

    return (
        <TileSchadflaechenSelectedComponent
            key={props.selectedAreaId}
            url={t.layersSchadflaechen[0].url}
            options={{
                interactive: true,
                rendererFactory: L.canvas.tile,
                vectorTileLayerStyles: schadflaechenStyles,
                zIndex: 101,
            }}
            eventHandlers={{
                click: (e: any) => {
                    let bundeslandSelected = "";
                    for (const [key, value] of Object.entries(t.bundeslaender)) {
                        const bundeslandValue = value as any; // Quick fix with type assertion

                        if (bundeslandValue.RS == e.layer.properties.RS) {
                            bundeslandSelected = bundeslandValue.label
                        }
                    }
                    props.setBundesland(bundeslandSelected)
                },
            }}
        />);
}